"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleTagManagerDataInjectionPlugin = void 0;
const googleTagManagerDataInjection_1 = __importDefault(require("./googleTagManagerDataInjection"));
exports.googleTagManagerDataInjectionPlugin = googleTagManagerDataInjection_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcGx1Z2lucy9jdXN0b20vaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsb0dBQWtGO0FBRXpFLDhDQUZGLHVDQUFtQyxDQUVFIn0=


// WEBPACK FOOTER //
// ../../../../src/plugins/custom/index.ts